module.exports = __webpack_public_path__ + "img/star_product_2.f7d4eba6.png";